import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatNodeTimeEnum } from '@src/public/utils/format';
import { EVENT_LIST_INFLOW } from '@src/public/constants';
import EventCard from '@src/pc/components/EventCard';
import styles from './index.css';

const cx = classNames.bind(styles);

const Item = ({ content, showType, allFold, parties, timeline, changeFold, index }) => {
    const { id, nodeTime, timeType, partyId, highlights } = content;

    if (!id) {
        return null;
    }

    const isInFlow = showType === EVENT_LIST_INFLOW;

    // 决定当前短内容收起展开的变量
    const [fold, setFold] = useState(true);

    // 当外部触发全部收起/展开时，强制当前短内容收起/展开
    useEffect(
        () => {
            setFold(allFold);
        },
        [allFold],
    );

    // 改变当前短内容收起展开状态
    const changeItemFold = bool => {
        setFold(bool);
        changeFold(id, bool);
    };

    // 点击当前短内容的收起按钮
    const handleFoldBtnClick = () => {
        changeItemFold(true);
    };

    // 点击收起状态的当前短内容
    const handleFoldWrapClick = () => {
        // 如果是嵌入热点专题或者未处于收起状态，直接返回
        if (isInFlow || !fold) {
            return;
        }

        changeItemFold(false);
    };

    const isHighLight = highlights === 1;
    const party = parties.find(item => item.id === partyId);
    const partyColor = isInFlow ? '#F54343' : party.color;

    return (
        <div className={styles.item}>
            <div className={styles.left}>
                <div className={styles.pointWrap}>
                    <div
                        className={cx('point', isHighLight ? 'pointHighlight' : 'pointNormal')}
                        style={isHighLight ? { color: partyColor } : { backgroundColor: partyColor }}
                    />
                </div>
                <div className={styles.line} />
            </div>
            <div className={styles.content}>
                <div className={styles.nav}>
                    <div className={styles.time}>{formatNodeTimeEnum(nodeTime, timeType)}</div>
                    {fold || isInFlow ? null : (
                        <div className={styles.foldBtn} onClick={handleFoldBtnClick}>
                            收起
                        </div>
                    )}
                </div>
                <div className={cx({ unfoldWrap: !fold })} onClick={handleFoldWrapClick}>
                    <EventCard content={content} timeline={timeline} showType={showType} fold={fold} index={index} />
                </div>
            </div>
        </div>
    );
};

Item.propTypes = {
    content: PropTypes.object,
    showType: PropTypes.string,
    allFold: PropTypes.bool,
    parties: PropTypes.array,
    timeline: PropTypes.object,
    changeFold: PropTypes.func,
    index: PropTypes.number,
};

export default errorBoundary(Item);
